var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCountCard',{attrs:{"value":_vm.TPAppsStats.TPAppsTotalCount,"unit":"طلب على منح البرامج التدريبية"}})}
var staticRenderFns = []

export { render, staticRenderFns }